import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'

export default function TooltipPopup({ show, setShow, reportTitle, reportDescription}) {
  return (
    <Modal show={show} onHide={setShow}>
    <Modal.Header closeButton>
      <Modal.Title>{reportTitle}</Modal.Title>
    </Modal.Header>
    <Modal.Body>{reportDescription}</Modal.Body>
    <Modal.Footer>
      <Button className='full-width' variant="secondary" onClick={()=>setShow(false)}>
        Close
      </Button>
    </Modal.Footer>
  </Modal>
  )
}